// extracted by mini-css-extract-plugin
export default {"actions":"learning-management_actions__UG0eS","name":"learning-management_name__Dko02","tooltip":"learning-management_tooltip__gdmJl"};